import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VAutocomplete,{ref:"toSpecField",attrs:{"disabled":!_vm.to.filter.doc,"clearable":"","color":"teal","label":"Specialization","items":_vm.getToSpecs,"item-text":"sp_name","auto-select-first":"","autocomplete":"nope","return-object":""},on:{"change":function($event){return _vm.handleChangeSpecField($event)}},model:{value:(_vm.specField),callback:function ($$v) {_vm.specField=$$v},expression:"specField"}})
}
var staticRenderFns = []

export { render, staticRenderFns }